import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "relative overflow-hidden bg-gray-900" }
const _hoisted_2 = { class: "relative z-10 mx-auto flex max-w-7xl items-center justify-between px-4 py-5 sm:px-6 lg:px-8" }
const _hoisted_3 = {
  href: "#",
  class: "flex items-center gap-2",
  "aria-label": "Himalia – domov"
}
const _hoisted_4 = { class: "hidden items-center gap-8 md:flex" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = {
  key: 0,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = {
  key: 1,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_9 = {
  key: 0,
  class: "relative z-20 border-t border-white border-opacity-10 bg-gray-800 px-4 py-4 md:hidden"
}
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", {
      class: "absolute inset-0",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", { class: "absolute -top-40 -right-32 h-96 w-96 rounded-full bg-brand-600 bg-opacity-30 blur-2xl" }),
      _createElementVNode("div", { class: "absolute top-1/2 -left-24 h-96 w-96 rounded-full bg-indigo-600 bg-opacity-20 blur-2xl animate-float" }),
      _createElementVNode("div", { class: "absolute bottom-0 right-1/4 h-72 w-72 rounded-full bg-indigo-500 bg-opacity-15 blur-2xl" })
    ], -1)),
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        _createVNode(_component_Logo, {
          class: "h-9 w-auto sm:h-10",
          "with-text": true,
          variant: "light"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
          return (_openBlock(), _createElementBlock("a", {
            key: item.link,
            href: item.link,
            class: "text-sm font-medium text-gray-300 transition hover:text-white"
          }, _toDisplayString(item.name), 9, _hoisted_5))
        }), 128)),
        _cache[3] || (_cache[3] = _createElementVNode("a", {
          href: "#kontakt",
          class: "btn-primary text-sm py-2 px-5"
        }, " Kontakt ", -1))
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.mobileMenu = !_ctx.mobileMenu)),
        type: "button",
        class: "inline-flex items-center justify-center rounded-lg p-2 text-gray-300 hover:bg-white hover:bg-opacity-10 hover:text-white md:hidden",
        "aria-expanded": _ctx.mobileMenu,
        "aria-label": "Menu"
      }, [
        (!_ctx.mobileMenu)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h16"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              }, null, -1)
            ]))]))
      ], 8, _hoisted_6)
    ]),
    _createVNode(_Transition, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "opacity-0 -translate-y-2",
      "enter-to-class": "opacity-100 translate-y-0",
      "leave-active-class": "transition duration-150 ease-in",
      "leave-from-class": "opacity-100 translate-y-0",
      "leave-to-class": "opacity-0 -translate-y-2"
    }, {
      default: _withCtx(() => [
        (_ctx.mobileMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: item.link,
                  href: item.link,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mobileMenu = false)),
                  class: "block rounded-lg px-3 py-2.5 text-base font-medium text-gray-200 hover:bg-white hover:bg-opacity-5 hover:text-white"
                }, _toDisplayString(item.name), 9, _hoisted_10))
              }), 128)),
              _createElementVNode("a", {
                href: "#kontakt",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mobileMenu = false)),
                class: "mt-2 block rounded-xl bg-brand-600 px-3 py-2.5 text-center font-semibold text-white"
              }, " Kontakt ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"relative z-10 mx-auto max-w-7xl px-4 pb-20 pt-8 sm:px-6 sm:pb-28 sm:pt-12 lg:px-8 lg:pb-36\"><div class=\"mx-auto max-w-3xl text-center\"><p class=\"mb-6 inline-flex items-center gap-2 rounded-full border border-white border-opacity-10 bg-white bg-opacity-5 px-4 py-1.5 text-sm font-medium text-gray-300\"><span class=\"h-2 w-2 rounded-full bg-green-400\"></span> IT firma zo Slovenska · od 2021 </p><h1 class=\"text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl\"> Využívame technológie <span class=\"mt-2 block text-brand-300\"> na maximum </span></h1><p class=\"mx-auto mt-6 max-w-2xl text-lg leading-8 text-gray-400 sm:text-xl\"> Navrhujeme, vyvíjame, integrujeme a testujeme software aj hardware s využitím najnovších technológií — od webu po embedded zariadenia. </p><div class=\"mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row\"><a href=\"#kontakt\" class=\"btn-primary w-full sm:w-auto\"> Kontaktujte nás </a><a href=\"#tim\" class=\"btn-secondary w-full sm:w-auto\"> Spoznajte tím </a></div></div></div><div class=\"relative z-10 -mb-px\"><svg class=\"w-full text-gray-50\" viewBox=\"0 0 1440 80\" fill=\"currentColor\" preserveAspectRatio=\"none\"><path d=\"M0,48 C320,80 480,0 720,32 C960,64 1120,16 1440,48 L1440,80 L0,80 Z\"></path></svg></div>", 2))
  ]))
}